import { Navigate, PathRouteProps } from "react-router-dom";
import { AppState } from "../store/configureStore";
import { useSelector } from "react-redux";

interface PrivateRouteProps extends PathRouteProps {
    component: any;
}

export const PrivateRoute = ({ component: Component }: PrivateRouteProps) => {
    const token = useSelector((state: AppState) => state.user.token);
    let loggedIn = useSelector((state: AppState) => state.login.loggedIn);

    if (token && loggedIn) {
        return <Component id="component-privateRoute" />
    }
    return <Navigate to="/login" />
}
